var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
var ExtendPropertyComponent = /** @class */ (function (_super) {
    __extends(ExtendPropertyComponent, _super);
    function ExtendPropertyComponent(injector, formData) {
        var _this = _super.call(this, injector) || this;
        _this.formData = formData;
        _this.validateChange = new EventEmitter();
        return _this;
    }
    Object.defineProperty(ExtendPropertyComponent.prototype, "borderColor", {
        get: function () {
            return this._borderColor;
        },
        set: function (v) {
            this.data.borderColor = v;
            this._borderColor = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyComponent.prototype, "backgroundColor", {
        get: function () {
            return this._backgroundColor;
        },
        set: function (v) {
            this.data.backgroundColor = v;
            this._backgroundColor = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyComponent.prototype, "barColor", {
        get: function () {
            return this._barColor;
        },
        set: function (v) {
            this.data.barColor = v;
            this._barColor = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyComponent.prototype, "useAlarmLimit", {
        get: function () {
            return this._useAlarmLimit;
        },
        set: function (v) {
            if (v) {
                this.data.alarmLimit.upperLimit = this._upperLimit;
                this.data.alarmLimit.lowerLimit = this._lowerLimit;
                this.data.alarmLimit.upperLimitColor = this._upperLimitColor;
                this.data.alarmLimit.upperLimitColor = this._lowerLimitColor;
            }
            else {
                delete this.data.alarmLimit;
            }
            this.data.useAlarmLimit = v;
            this._useAlarmLimit = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyComponent.prototype, "upperLimit", {
        get: function () {
            return this._upperLimit;
        },
        set: function (v) {
            this.data.alarmLimit.upperLimit = v;
            this._upperLimit = v;
            this.validateErrorEmit();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyComponent.prototype, "lowerLimit", {
        get: function () {
            return this._lowerLimit;
        },
        set: function (v) {
            this.data.alarmLimit.lowerLimit = v;
            this._lowerLimit = v;
            this.validateErrorEmit();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyComponent.prototype, "upperLimitColor", {
        get: function () {
            return this._upperLimitColor;
        },
        set: function (v) {
            this.data.alarmLimit.upperLimitColor = v;
            this._upperLimitColor = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyComponent.prototype, "lowerLimitColor", {
        get: function () {
            return this._lowerLimitColor;
        },
        set: function (v) {
            this.data.alarmLimit.lowerLimitColor = v;
            this._lowerLimitColor = v;
        },
        enumerable: true,
        configurable: true
    });
    ExtendPropertyComponent.prototype.ngOnInit = function () {
        var data = this.data;
        this._borderColor = data.borderColor;
        this._backgroundColor = data.backgroundColor;
        this._barColor = data.barColor;
        this._useAlarmLimit = data.useAlarmLimit;
        this._upperLimit = data.alarmLimit.upperLimit;
        this._lowerLimit = data.alarmLimit.lowerLimit;
        this._upperLimitColor = data.alarmLimit.upperLimitColor;
        this._lowerLimitColor = data.alarmLimit.lowerLimitColor;
    };
    ExtendPropertyComponent.prototype.validateErrorEmit = function () {
        var validateError = this._upperLimit <= this._lowerLimit;
        this.validateChange.emit(validateError);
    };
    ExtendPropertyComponent.prototype.setUpperLimitColor = function (color) {
        this.upperLimitColor = color;
    };
    ExtendPropertyComponent.prototype.setLowerLimitColor = function (color) {
        this.lowerLimitColor = color;
    };
    ExtendPropertyComponent.prototype.setBorderColor = function (color) {
        this.borderColor = color;
    };
    ExtendPropertyComponent.prototype.setBackgroundColor = function (color) {
        this.backgroundColor = color;
    };
    ExtendPropertyComponent.prototype.setBarColor = function (color) {
        this.barColor = color;
    };
    __decorate([
        Input()
    ], ExtendPropertyComponent.prototype, "data", void 0);
    __decorate([
        Output()
    ], ExtendPropertyComponent.prototype, "validateChange", void 0);
    ExtendPropertyComponent = __decorate([
        Component({
            selector: 'extend-property',
            styles: [".extend-property{ .form-inline-label{ float: left; margin-top:3px; } .bar-color{ margin-top: 10px; margin-bottom: 20px; } } "],
            template: "<div class=\"fe-modal-content\" provide-parent-forms> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line float-left\"> <div class=\"fe-transverse-title\">{{lc(\"BorderColor\")}}:</div> <div class=\"fe-transverse-component\"> <color-picker [color]=\"borderColor\" (sentColor)=\"setBorderColor($event)\"></color-picker> </div> </div> <div class=\"fe-half-line float-left\"> <div class=\"fe-transverse-title\">{{lc(\"BackgroundColor\")}}:</div> <div class=\"fe-transverse-component\"> <color-picker [color]=\"backgroundColor\" (sentColor)=\"setBackgroundColor($event)\"></color-picker> </div> </div> <div class=\"fe-half-line float-left margin-top-10\"> <div class=\"fe-transverse-title\">{{lc(\"BarColor\")}}:</div> <div class=\"fe-transverse-component\"> <color-picker [color]=\"barColor\" (sentColor)=\"setBarColor($event)\"></color-picker> </div> </div> </div> <div class=\"fe-modal-body  margin-top-10\"> <div class=\"fe-option-head\"> <label> <input type=\"checkbox\" name=\"useAlarmLimit\" [(ngModel)]=\"useAlarmLimit\"> <span>{{lc(\"AlarmLimit\")}}</span> </label> </div> </div> <div class=\"clearfix\" *ngIf=\"useAlarmLimit\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"LowerLimit\")}}:</div> <input type=\"number\" required name=\"LowerLimit\" class=\"fe-vertical-input\" [(ngModel)]=\"lowerLimit\" /> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"UpperLimit\")}}:</div> <input type=\"number\" name=\"UpperLimit\" #UpperLimit=\"ngModel\" class=\"fe-vertical-input\" [(ngModel)]=\"upperLimit\" /> </div> </div> <div *ngIf=\"useAlarmLimit && (lowerLimit > upperLimit)\" class=\"fe-vertical-label\"> <div class=\"fe-vertical-title has-danger\"> <div class=\"form-control-feedback\">{{lc(\"UpperLowerLimitError\")}}</div> </div> </div> <div class=\"fe-transverse-label clearfix margin-top-10\" *ngIf=\"useAlarmLimit\"> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"LowerLimitColor\")}}:</label> <div class=\"fe-transverse-component\"> <color-picker [color]=\"lowerLimitColor\" (sentColor)=\"setLowerLimitColor($event)\"></color-picker> </div> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"UpperLimitColor\")}}:</label> <div class=\"fe-transverse-component\"> <color-picker [color]=\"upperLimitColor\" (sentColor)=\"setUpperLimitColor($event)\"></color-picker> </div> </div> </div> </div>"
        })
    ], ExtendPropertyComponent);
    return ExtendPropertyComponent;
}(ConfigureComponentBase));
export { ExtendPropertyComponent };
